export const PACKAGE_NAME = '@jira/navigation-apps__atlassian-navigation' as const;
// TODO: If we change the package name, do we need to change any monitoring?
// export const PACKAGE_NAME = '@jira/navigation-apps__topnav-common' as const;

export const TOP_LEVEL_ERROR_BOUNDARY_ID = 'TOP_LEVEL' as const;

export const NAVIGATION_ITEM_ID__APP_SWITCHER = 'atlassianSwitcher' as const;
